(() => {
  class VoHeaderPromos {
    constructor(root) {
      this.root = root;
      this.promo = root.querySelector('[data-vo-header-promo]');
      this.activeIndex = 0;
      this.autoRotateTimer = null;
      this.countdownTimer = null;

      this.initPromo();
      this.countdowns = Array.from(root.querySelectorAll('[data-vo-header-countdown]'));
      if (this.slides?.length) this.initCountdowns();
    }

    initPromo() {
      if (!this.promo) return;

      this.slides = Array.from(this.promo.querySelectorAll('[data-vo-header-promo-slide]'));
      this.prevButton = this.promo.querySelector('[data-vo-header-promo-prev]');
      this.nextButton = this.promo.querySelector('[data-vo-header-promo-next]');

      this.promo.dataset.promoCount = String(this.slides.length);
      if (this.prevButton) this.prevButton.disabled = this.slides.length < 2;
      if (this.nextButton) this.nextButton.disabled = this.slides.length < 2;
      if (!this.slides.length) {
        this.root.closest('.shopify-section')?.remove();
        return;
      }
      this.showSlide(0);
      if (this.slides.length <= 1) return;

      this.prevButton?.addEventListener('click', () => {
        this.showSlide(this.activeIndex - 1);
        this.restartAutoRotate();
      });

      this.nextButton?.addEventListener('click', () => {
        this.showSlide(this.activeIndex + 1);
        this.restartAutoRotate();
      });

      this.promo.addEventListener('mouseenter', () => this.stopAutoRotate());
      this.promo.addEventListener('mouseleave', () => this.startAutoRotate());

      this.startAutoRotate();
    }

    showSlide(index) {
      if (!this.slides?.length) return;

      this.activeIndex = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    startAutoRotate() {
      if (!this.promo || this.promo.dataset.autoplay !== 'true' || this.slides.length <= 1) {
        return;
      }

      const interval = Number(this.promo.dataset.interval || '5000');
      this.stopAutoRotate();
      this.autoRotateTimer = window.setInterval(() => {
        this.showSlide(this.activeIndex + 1);
      }, interval);
    }

    stopAutoRotate() {
      if (this.autoRotateTimer) {
        window.clearInterval(this.autoRotateTimer);
        this.autoRotateTimer = null;
      }
    }

    restartAutoRotate() {
      this.stopAutoRotate();
      this.startAutoRotate();
    }

    destroy() {
      this.stopAutoRotate();

      if (this.countdownTimer) {
        window.clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    }

    initCountdowns() {
      if (!this.countdowns.length) return;

      this.updateCountdowns();
      this.countdownTimer = window.setInterval(() => {
        this.updateCountdowns();
      }, 1000);
    }

    updateCountdowns() {
      this.countdowns.forEach((node) => {
        const targetDate = new Date(node.dataset.targetDate || '');
        const targetTime = targetDate.getTime();

        if (Number.isNaN(targetTime)) {
          node.textContent = node.dataset.targetDate || '';
          return;
        }

        const hourDigits = this.getCountdownHourDigits(node, targetTime);
        const remainingMs = Math.max(targetTime - Date.now(), 0);
        const totalSeconds = Math.floor(remainingMs / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        node.textContent = `${this.pad(hours, hourDigits)} H : ${this.pad(minutes)} M : ${this.pad(seconds)} S`;
      });
    }

    getCountdownHourDigits(node, targetTime) {
      if (!node.dataset.voHeaderCountdownHourDigits) {
        const remainingMs = Math.max(targetTime - Date.now(), 0);
        const totalHours = Math.floor(remainingMs / 1000 / 3600);
        const hourDigits = Math.max(String(totalHours).length, 2);
        const countdownTemplate = `${'0'.repeat(hourDigits)} H : 00 M : 00 S`;

        node.dataset.voHeaderCountdownHourDigits = String(hourDigits);
        node.style.setProperty('--vo-header-countdown-min-width', `${countdownTemplate.length}ch`);
      }

      return Number(node.dataset.voHeaderCountdownHourDigits || 2);
    }

    pad(value, minLength = 2) {
      return String(value).padStart(minLength, '0');
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-vo-header-promos]').forEach((root) => {
      if (root.dataset.voHeaderPromosReady === 'true') return;
      root.dataset.voHeaderPromosReady = 'true';
      root.__voHeaderPromosInstance = new VoHeaderPromos(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-vo-header-promos]').forEach((root) => {
      root.__voHeaderPromosInstance?.destroy();
      root.__voHeaderPromosInstance = null;
      root.dataset.voHeaderPromosReady = 'false';
    });
  });
})();
